module.exports = __webpack_public_path__ + "media/src/images/bg_fvHeading_logo-ea87ac07ded801eadb2a7704403bcc60.png";